export const getRedirectURI = () => {
  const origin = window.location.origin;
  const envValue = process.env.REACT_APP_DEPLOYMENT_ENV_NAME;
  // ATTENTION: ?ds=development params is read and used on Auth0 post-login script, do not remove!
  const deploymentQueryStringService = envValue ? `?ds=${envValue}` : '';
  return `${origin}/auth${deploymentQueryStringService}`; // Standalone mode
};
